"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var graphic_1 = require("../../shared/models/graphic");
var size_chart_1 = require("../../shared/models/size_chart");
var measurement_unit_1 = require("../../shared/models/measurement_unit");
var client_1 = __importDefault(require("../apollo/client"));
var Annotations_1 = require("../components/Annotations");
var billing_1 = require("../../shared/util/billing");
var settings_1 = require("../../shared/util/settings");
var MeasurementActionType;
(function (MeasurementActionType) {
    MeasurementActionType["SHOW_MEASUREMENT_GRAPHICS"] = "ui_SHOW_MEASUREMENT_GRAPHICS";
    MeasurementActionType["HIDE_GRAPHICS"] = "ui_HIDE_GRAPHICS";
    MeasurementActionType["TOGGLE_UNIT"] = "ui_TOGGLE_UNIT";
    MeasurementActionType["SHOW_SIZE_CHART"] = "ui_SHOW_SIZE_CHART";
    MeasurementActionType["HIDE_SIZE_CHART"] = "ui_HIDE_SIZE_CHART";
    MeasurementActionType["MEASUREMENTS_LOAD"] = "ui_MEASUREMENTS_LOAD";
    MeasurementActionType["MEASUREMENTS_LOADED_SUCCESS"] = "ui_MEASUREMENTS_LOADED_SUCCESS";
    MeasurementActionType["MEASUREMENTS_LOADED_FAILURE"] = "ui_MEASUREMENTS_LOADED_FAILURE";
    MeasurementActionType["HAS_MEASUREMENTS_FOR_PRODUCT"] = "ui_HAS_MEASUREMENTS_FOR_PRODUCT";
    MeasurementActionType["MEASUREMENTS_SHOW_VARIANT"] = "ui_MEASUREMENTS_SHOW_VARIANT";
})(MeasurementActionType = exports.MeasurementActionType || (exports.MeasurementActionType = {}));
exports.initialState = {
    displayUnit: measurement_unit_1.metric,
    displayVariantId: undefined,
    annotationsDisplay: Annotations_1.AnnotationsDisplay.HIDE,
    graphics: graphic_1.EmptyGraphicCollection,
    canToggleGraphics: false,
    defaultOptions: [],
    optionLabels: [],
    optionsToVariantId: {},
    optionChoices: {},
    sizeChart: size_chart_1.EmptySizeChart,
    showSizeChart: false,
    canToggleSizeChart: false,
    measurementsLoading: false,
    measurementsLoaded: false,
    loadingErrors: [],
    trialExpired: false,
};
exports.optionsHash = function (options) { return options.toString(); };
var extractGraphics = function (jsonData) {
    var images = jsonData.product && jsonData.product.images || [];
    var graphics = {};
    images.forEach(function (jsonImage) {
        var jsonGraphics = jsonImage.graphics || [];
        jsonGraphics.forEach(function (jsonGraphic) {
            var dimension = jsonGraphic.dimension;
            var dimensionKey = dimension.id;
            var startX = (jsonGraphic.startX || 0);
            var startY = (jsonGraphic.startY || 0);
            var start = { xPercent: startX * 100, yPercent: startY * 100 };
            var endX = (jsonGraphic.endX || 0);
            var endY = (jsonGraphic.endY || 0);
            var end = { xPercent: endX * 100, yPercent: endY * 100 };
            var labelX = jsonGraphic.labelCenterX;
            var labelY = jsonGraphic.labelCenterY;
            var labelPoint = labelX !== null && labelY !== null
                && { xPercent: labelX * 100, yPercent: labelY * 100 }
                || undefined;
            var color = jsonGraphic.color || "#FFFFFF";
            var id = jsonGraphic.id;
            var fontSize = jsonGraphic.fontSize || graphic_1.DEFAULT_FONT_SIZE;
            var graphicCollection = graphics[jsonImage.shopifyImageId] || [];
            graphicCollection.push({
                id: id,
                uniqueKey: id,
                dimensionKey: dimensionKey,
                start: start,
                end: end,
                labelPoint: labelPoint,
                color: color,
                fontSize: fontSize,
            });
            graphics[jsonImage.shopifyImageId] = graphicCollection;
        });
    });
    var jsonDimensionOrder = jsonData.product
        && jsonData.product.dimensions || [];
    var dimensionOrder = jsonDimensionOrder.map(function (jsonDimension) {
        return {
            id: jsonDimension.id,
            name: jsonDimension.name,
            showInSizeChart: jsonDimension.showInSizeChart,
            uniqueKey: jsonDimension.id,
        };
    });
    return {
        graphics: graphics,
        dimensionOrder: dimensionOrder,
    };
};
var extractSizeChart = function (optionLabels, jsonData) {
    var unit = settings_1.defaultUnit();
    // in the form of "option{1,2,3}"
    var topLevelOption = jsonData.product && jsonData.product.topLevelOption;
    var topLevelIndexStr = topLevelOption && topLevelOption.split("option")[1];
    var topLevelIndex = parseInt(topLevelIndexStr || "", 10) - 1;
    var topLevelOptionLabel = isFinite(topLevelIndex) && optionLabels[topLevelIndex] || undefined;
    var measurements = [];
    var jsonVariants = jsonData.product && jsonData.product.variants || [];
    jsonVariants.forEach(function (jsonVariant) {
        var variantId = jsonVariant.shopifyVariantId;
        var measurementsJson = jsonVariant.measurements || [];
        measurementsJson.forEach(function (measurementJson) {
            var dimensionKey = measurementJson.dimension.id;
            var startLengthM = measurementJson.startLengthM || 0;
            var startLength = unit === measurement_unit_1.metric ? startLengthM * 100 : size_chart_1.cmToInches(startLengthM * 100);
            var endLengthM = measurementJson.endLengthM;
            var endLength;
            if (endLengthM !== null) {
                endLength = unit === measurement_unit_1.metric ? endLengthM * 100 : size_chart_1.cmToInches(endLengthM * 100);
            }
            measurements.push({ variantId: variantId, dimensionKey: dimensionKey, startLength: startLength, endLength: endLength });
        });
    });
    var availableOptionLabels = [];
    if (jsonData.product) {
        if (jsonData.product.option1InSizeChart && optionLabels[0]) {
            availableOptionLabels.push(optionLabels[0]);
        }
        if (jsonData.product.option2InSizeChart && optionLabels[1]) {
            availableOptionLabels.push(optionLabels[1]);
        }
        if (jsonData.product.option3InSizeChart && optionLabels[2]) {
            availableOptionLabels.push(optionLabels[2]);
        }
    }
    return {
        unit: unit,
        measurements: measurements,
        topLevelOptionLabel: topLevelOptionLabel,
        availableOptionLabels: availableOptionLabels,
    };
};
var PRODUCT_FRONTEND_QUERY = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "productFrontend" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, "defaultValue": undefined }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "product" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "shopifyProductId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productId" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "topLevelOption" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "option1InSizeChart" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "option2InSizeChart" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "option3InSizeChart" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "showGraphics" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "showSizeChart" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "variants" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "shopifyVariantId" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "measurements" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "startLengthM" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "endLengthM" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "dimension" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "dimensions" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "name" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "showInSizeChart" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "images" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "shopifyImageId" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "graphics" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "color" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "startX" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "startY" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "endX" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "endY" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "labelCenterX" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "labelCenterY" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "fontSize" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "dimension" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "name" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "billing" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "id" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "status" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "plan" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 842, "source": { "body": "\n  query productFrontend($productId: String!) {\n    product(shopifyProductId: $productId) {\n      topLevelOption\n\n      option1InSizeChart\n      option2InSizeChart\n      option3InSizeChart\n\n      showGraphics\n      showSizeChart\n      variants {\n        shopifyVariantId\n        measurements {\n          startLengthM\n          endLengthM\n          dimension {\n            id\n          }\n        }\n      }\n      dimensions {\n        id\n        name\n        showInSizeChart\n      }\n      images {\n        shopifyImageId\n        graphics {\n          id\n          color\n          startX\n          startY\n          endX\n          endY\n          labelCenterX\n          labelCenterY\n          fontSize\n          dimension {\n            id\n            name\n          }\n        }\n      }\n    }\n    billing {\n      id\n      status\n      plan\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
exports.loadSizeChartAndAnnotations = function (shopifyProductId, dispatch, showMeasurements, showSizeChart) {
    dispatch({ type: MeasurementActionType.MEASUREMENTS_LOAD });
    client_1.default.query({
        query: PRODUCT_FRONTEND_QUERY,
        variables: { productId: shopifyProductId },
    }).then(function (result) {
        var hasErrors = result.errors && result.errors.length > 0;
        if (hasErrors) {
            return dispatch({
                type: MeasurementActionType.MEASUREMENTS_LOADED_FAILURE,
                errors: (result.errors || []).map(function (error) { return error.message; }),
            });
        }
        if (result.data.product) {
            dispatch({
                type: MeasurementActionType.HAS_MEASUREMENTS_FOR_PRODUCT,
            });
        }
        dispatch({
            type: MeasurementActionType.MEASUREMENTS_LOADED_SUCCESS,
            payload: result.data,
        });
        if (showMeasurements) {
            dispatch({ type: MeasurementActionType.SHOW_MEASUREMENT_GRAPHICS });
        }
        else if (showSizeChart) {
            dispatch({ type: MeasurementActionType.SHOW_SIZE_CHART });
        }
    });
};
exports.reducer = function (oldState, action) {
    if (oldState === void 0) { oldState = exports.initialState; }
    switch (action.type) {
        case MeasurementActionType.SHOW_MEASUREMENT_GRAPHICS: {
            var hasGraphics = Object.keys(oldState.graphics.graphics).length > 0;
            if (oldState.canToggleGraphics && hasGraphics) {
                return __assign({}, oldState, { annotationsDisplay: Annotations_1.AnnotationsDisplay.SHOW_MEASUREMENTS });
            }
            return oldState;
        }
        case MeasurementActionType.HIDE_GRAPHICS: {
            if (oldState.canToggleGraphics) {
                return __assign({}, oldState, { annotationsDisplay: Annotations_1.AnnotationsDisplay.HIDE });
            }
            return oldState;
        }
        case MeasurementActionType.SHOW_SIZE_CHART: {
            var hasMeasurements = oldState.sizeChart.measurements.length > 0;
            if (oldState.canToggleSizeChart && hasMeasurements) {
                return __assign({}, oldState, { showSizeChart: true });
            }
            return oldState;
        }
        case MeasurementActionType.HIDE_SIZE_CHART: {
            if (oldState.canToggleSizeChart) {
                return __assign({}, oldState, { showSizeChart: false });
            }
            return oldState;
        }
        case MeasurementActionType.TOGGLE_UNIT: {
            var isMetric = oldState.displayUnit === measurement_unit_1.metric;
            return __assign({}, oldState, { displayUnit: isMetric ? measurement_unit_1.imperial : measurement_unit_1.metric });
        }
        case MeasurementActionType.MEASUREMENTS_SHOW_VARIANT: {
            return __assign({}, oldState, { displayVariantId: action.variantId });
        }
        case MeasurementActionType.MEASUREMENTS_LOAD: {
            return __assign({}, oldState, { measurementsLoading: true, measurementsLoaded: false });
        }
        case MeasurementActionType.MEASUREMENTS_LOADED_SUCCESS: {
            var payload = action.payload;
            var graphics = extractGraphics(payload);
            var sizeChart = extractSizeChart(oldState.optionLabels, payload);
            var unit = settings_1.defaultUnit();
            var canToggleGraphics = payload.product
                && payload.product.showGraphics
                || false;
            var canToggleSizeChart = payload.product
                && payload.product.showSizeChart
                || false;
            var trialExpired = billing_1.hasExpiredTrial(payload.billing);
            return __assign({}, oldState, { graphics: graphics,
                canToggleGraphics: canToggleGraphics,
                sizeChart: sizeChart,
                canToggleSizeChart: canToggleSizeChart, measurementsLoading: false, measurementsLoaded: true, displayUnit: unit, trialExpired: trialExpired });
        }
        case MeasurementActionType.MEASUREMENTS_LOADED_FAILURE: {
            // TODO(jeffk): bug snag
            return __assign({}, oldState, { measurementsLoading: false, measurementsLoaded: true, loadingErrors: action.errors });
        }
        default: {
            return oldState;
        }
    }
};
